<template>
  <!-- 新增修改 -->
  <el-dialog v-model="addialog" :title="info.userId ? '编辑顾客' : '新增顾客'" width="650px" @close="close" :append-to-body="true">
    <el-card style="width: 100%;">
      <el-row>
        <el-col style="margin-top: 20px;">
          <el-form ref="addFormRef" :rules="rules" label-width="100px" :model="info" style="max-width: 550px;">
            <el-form-item label="姓名" prop="userName">
              <el-input v-model="info.userName" placeholder="请输入顾客姓名" style="max-width: 320px; margin-right: 10px;"></el-input>
              <el-select-v2 v-model="info.sex" :options="agelist" placeholder="请选择性别" style="max-width: 120px;" />
            </el-form-item>
            <el-form-item label="手机号码：" prop="phonenumber">
              <el-input v-model="info.phonenumber" placeholder="请输入顾客电话" />
            </el-form-item>
            <el-form-item label="所属门店：">
              <el-select v-model="info.sourceShop" placeholder="请选择门店">
                <el-option v-for="item in shopList" :key="item.shopId" :label="item.shopName" :value="item.shopId">
                </el-option>
            </el-select>
            </el-form-item>
            <el-form-item label="生日">
              <el-select-v2 v-model="info.birthDayTimeType" :options="dataList" placeholder="请选择" style="max-width: 120px; margin-right: 10px;" />
              <el-date-picker
                v-model="info.birthday"
                type="date"
                placeholder="请选择日期"
                @focus="forbid"
                style="width: 320px;"
              />
            </el-form-item>
            <el-form-item label="备注">
              <el-input v-model="info.remark" type="textarea" placeholder="请输入备注" />
            </el-form-item>
            <el-form-item label="上传头像">
                <el-upload
                    class="logo-uploader"
                    :action="action"
                    :headers="header"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :before-upload="beforeAvatarUpload"
                >
                    <img v-if="info.avatar" :src="info.avatar" class="logo" />
                    <el-icon v-else class="logo-uploader-icon"><Plus /></el-icon>
                </el-upload>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </el-card>
    <template #footer>
      <div class="dialog-footer">
        <div>
          <el-button type="primary" @click="close">取消</el-button>
          <el-button type="primary" @click="submitAdd(addFormRef)">保存</el-button>
        </div>
      </div>
    </template>
  </el-dialog>
</template>
<script setup lang="ts" async>
import { getShopList } from '@/api/common';
import { getToken } from '@/api';
import { UploadProps, FormRules, FormInstance, ElMessage, ElButton } from 'element-plus'
import { computed, reactive, ref, watch } from 'vue'
import { addCustomer, updateCustomer } from '@/api/customer';

const props = defineProps({
  show: {
    type: Boolean,
    default: () => false
  },
  data: {
    type: Object,
    default: () => {}
  }
})

const agelist = [
    {
        value: '0',
        label: '男',
    },
    {
        value: '1',
        label: '女',
    },
]
const dataList = [
    {
        value: 1,
        label: '农历',
    },
    {
        value: 2,
        label: '阳历',
    },
]
const shopList = ref([])
const addialog = ref(props.show)
const info = ref(props.data)
const addFormRef = ref<FormInstance>()
const rules = reactive<FormRules>({
    userName: [
        { required: true, message: '请输入客户名称', trigger: 'blur' }
    ],
    phonenumber: [
        { required: true, message: '请输入顾客电话', trigger: 'blur' },
        {
            pattern: /^1[2|3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: "请输入正确的手机号码",
            trigger: "blur",
        },
    ]
})

const action = ref(import.meta.env.VITE_BASE_URL + '/common/upload');
const header = computed(() => {
    return {
        "Authorization": "Bearer " + getToken()
    }
})

const getShop = async () => {
    const res = await getShopList()
    shopList.value = res.data
}
getShop();

const handleAvatarSuccess: UploadProps['onSuccess'] = (
  response,
  uploadFile
) => {
  info.value.avatar = response.url
}
const beforeAvatarUpload: UploadProps['beforeUpload'] = (rawFile) => {
  if (rawFile.type !== 'image/jpeg') {
    ElMessage.error('请上传照片!')
    return false
  } else if (rawFile.size / 1024 / 1024 > 10) {
    ElMessage.error('请上传不要超过10MB的照片!')
    return false
  }
  return true
}

const submitAdd = async (formEl: FormInstance | undefined) => {
  if (!formEl) return
  await formEl.validate((valid: any, fields: any) => {
    if (valid) {
      if(info.value.userId) {
        info.value.userType = '01';
        updateCustomer(info.value).then(res => {
          if(res.ok) {
            ElMessage({
                showClose: true,
                message: '修改成功',
                type: 'success',
                center: true,
                offset: 200
            })
            emit('close')
          }
        })
      }else {
        addCustomer(info.value).then(res => {
          if(res.ok) {
            ElMessage({
                showClose: true,
                message: '新增成功',
                type: 'success',
                center: true,
                offset: 200
            })
            emit('close')
          }
        })
      }
    }
  })
}

const forbid = () => {
    //禁止软键盘弹出
    document.activeElement.blur();
}

const emit = defineEmits(['close'])
const close = () => {
    emit('close')
}

</script>
<style lang="scss" scoped>
.itemList {
  width: 32%;
  margin-right: 1%;
  margin-bottom: 10px;
  border-radius: 15px;
  border: 1px solid #ccc;
  overflow: hidden;

  .title {
    display: flex;
    background: #F5F5F5;
    padding: 10px 20px;

    .lef {
      width: 70%;

      :first-child {
        font-size: 20px;
        color: #878787;
      }

      :last-child {
        font-size: 14px;
        color: #D0D0D0;
      }
    }

    .rig {
      width: 30%;
      text-align: right;
      line-height: 40px;
    }

  }

  .centerlist {
    width: 100%;
    background: #fff;
    padding: 10px 20px;
    font-feature-settings: "kern" on;
    color: #919191;
    font-size: 14px;

    .txt-right {
      text-align: right;
      margin-bottom: 10px;
    }

    .txt-rightc {
      text-align: right;
      color: #56875E;
    }

  }
}

.logo-uploader .logo {
  width: 70px;
  height: 70px;
  display: block;
}
.logo-uploader .el-upload {
  border: 1px dashed var(--el-border-color);
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: var(--el-transition-duration-fast);
}

.logo-uploader .el-upload:hover {
  border-color: var(--el-color-primary);
}
.el-icon.logo-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 70px;
  height: 70px;
  text-align: center;
  background: #FAFAFA;
}
</style>